  document.addEventListener('DOMContentLoaded', function () {
    const locationSelector = document.querySelector('.location-selector-lg select');
    console.log(window.customerEmail);
    const customerLoggedIn = window.customerEmail !== '';
    const customerEmail = customerLoggedIn ? window.customerEmail : null;

    function saveLocationData(isCanarias) {
      const now = new Date();
      const dateLimit = new Date(now.getTime() + 5 * 60000); // +5 min

      const data = {
        canariasMode: isCanarias,
        dateLimit: dateLimit.toISOString()
      };

      localStorage.setItem('canariasData', JSON.stringify(data));
    }

    function handleLocationChange(value) {
      const isCanarias = value === 'canarias';
      saveLocationData(isCanarias);

      if (!customerLoggedIn) {
        // Si no está logado, redirigir a login
        window.location.href = '/account/login';
      } else {
        // Si está logado, hacer fetch directamente
        sendLocationFetch(isCanarias, customerEmail);
      }
    }

    function sendLocationFetch(isCanarias, email) {
      fetch('https://toyplanet.lineagrafica.es/api/canarias', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          canariasMode: isCanarias,
          email: email
        })
      })
      .then(res => {
        res.json()
      })
      .then(data => {
        console.log('Fetch exitoso:', data);
        localStorage.removeItem('canariasData'); 
        location.reload();
      })
      .catch(err => {
        console.error('Error en fetch:', err);
      });

    }

    // Evento: cambio de selector
    if (locationSelector) {
      locationSelector.addEventListener('change', function () {
        handleLocationChange(locationSelector.value);
      });
    }

    // Post-login: revisar localStorage y hacer fetch si corresponde
    const stored = localStorage.getItem('canariasData');
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        const now = new Date();
        const expiry = new Date(parsed.dateLimit);

        if (locationSelector) {
          locationSelector.value = parsed.canariasMode ? 'canarias' : 'peninsula';
        }

        console.log(window.customerEmail);
        console.log(customerLoggedIn);
        if (now <= expiry && customerLoggedIn) {
          sendLocationFetch(parsed.canariasMode, customerEmail);
        }

        localStorage.removeItem('canariasData');
      } catch (e) {
        console.error('Error con localStorage:', e);
        localStorage.removeItem('canariasData');
      }
    }
  });